import { AppUser } from '@modules/company-manager/users/domain';
import { CacheableState } from '@utils/cacheable-state';
import { Company } from '../../domain';

export interface CompanyState {
  allCompanies: CacheableState<Array<Company>>;
  companyById: CacheableState<Array<any>>;
  updateCompany: CacheableState<Array<any>>;
  removeMember: CacheableState<Array<any>>;
  memberById: CacheableState<AppUser>;
  deleteCompany: CacheableState<Company>;
  sendInvoice: CacheableState<Array<any>>;
  paymentHistory: CacheableState<Company>;
  addCompany: CacheableState<Array<any>>;
  approverByCompanyId: CacheableState<Array<any>>;
  contactCompany: CacheableState<Array<any>>;
  validateCompany: CacheableState<Array<any>>;
}

export function companyInitialState(): CompanyState {
  return {
    allCompanies: initialDataSubState().allCompanies,
    companyById: initialDataSubState().companyById,
    updateCompany: initialDataSubState().updateCompany,
    removeMember: initialDataSubState().removeMember,
    memberById: initialDataSubState().memberById,
    deleteCompany: initialDataSubState().deleteCompany,
    sendInvoice: initialDataSubState().sendInvoice,
    paymentHistory: initialDataSubState().paymentHistory,
    addCompany: initialDataSubState().addCompany,
    approverByCompanyId: initialDataSubState().approverByCompanyId,
    contactCompany: initialDataSubState().contactCompany,
    validateCompany: initialDataSubState().validateCompany,
  };
}
export function initialDataSubState(): CompanyState {
  return {
    allCompanies: new CacheableState(),
    companyById: new CacheableState(),
    updateCompany: new CacheableState(),
    removeMember: new CacheableState(),
    memberById: new CacheableState(),
    deleteCompany: new CacheableState(),
    sendInvoice: new CacheableState(),
    paymentHistory: new CacheableState(),
    addCompany: new CacheableState(),
    approverByCompanyId: new CacheableState(),
    contactCompany: new CacheableState(),
    validateCompany: new CacheableState(),
  };
}
